var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "linkedin_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#linkedin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.697 18.422v-.042a.942.942 0 0 1-.027.042h.027Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.326 6H8.003C6.886 6 5.98 6.884 5.98 7.973v23.596c0 1.088.905 1.972 2.022 1.972h23.323c1.117 0 2.023-.884 2.023-1.972V7.973c0-1.09-.906-1.973-2.023-1.973Zm-17.05 23.055h-4.133V16.62h4.133v12.436ZM12.21 14.921h-.028c-1.386 0-2.283-.956-2.283-2.149 0-1.22.924-2.148 2.338-2.148 1.414 0 2.284.928 2.312 2.148 0 1.193-.898 2.149-2.339 2.149Zm16.972 14.134H25.05v-6.654c0-1.671-.598-2.812-2.094-2.812-1.142 0-1.822.769-2.121 1.512-.11.265-.136.636-.136 1.009v6.945h-4.134s.055-11.27 0-12.436h4.134v1.76c.55-.847 1.532-2.054 3.726-2.054 2.72 0 4.759 1.778 4.759 5.598v7.132Z"
}))));
export default SvgLinkedin;